import {
  ANSWER_INVALID_COPY,
  EMAIL_UNDELIVERABLE_COPY,
  GENERAL_ERROR,
} from '../data/application-copy';

const FIELD_ERROR_COPY = {
  EMAIL_UNDELIVERABLE: EMAIL_UNDELIVERABLE_COPY,
  CANDIDATE_FIELD_ANSWER_INVALID: ANSWER_INVALID_COPY,
};

// Keys come from Rebecca's response, so inherited names like "constructor"
// must not resolve.
const ownValue = (table, key) =>
  key !== undefined && Object.prototype.hasOwnProperty.call(table, key)
    ? table[key]
    : undefined;

// Rebecca reports one error per response, so at most one is live: either
// { kind: 'field', fieldId, message } under the field it names, or
// { kind: 'general', message } on the line below the button.
export const resolveServerError = (failure, renderedFieldIds) => {
  const copy = ownValue(FIELD_ERROR_COPY, failure.id);
  if (!copy) return { kind: 'general', message: GENERAL_ERROR };

  const message = ownValue(copy.byReason, failure.reason) || copy.fallback;

  // A field message whose field isn't on screen still has to be seen.
  if (failure.fieldId && renderedFieldIds.indexOf(failure.fieldId) !== -1) {
    return { kind: 'field', fieldId: failure.fieldId, message };
  }
  return { kind: 'general', message };
};
